<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
    import{getLang,UrlDecode,getValue,setValue} from "@/utils/pub"
import{Login} from "@/api/index"
export default {
  name: 'App',
  data() {
    return {
        port:'',
      ip:'',
    }
  },
    created(){
      this.init()
     // this.alert_ok("create")
       if(this.isMobile()){
         //this.alert_ok('is mobile')
 //this.$router.push({name: '/invoice' })
       }else{
//this.alert_ok('is pc')
       }
        },
   methods: {
          getlan(name){ var str=this.$t('lang.'+name+''); if(str.indexOf("lang.")>=0){ return name; }return str },
  init(){
  //  this.alert_ok(getValue("lan"))

           if(window.location.host.indexOf(":")>0){

         this.ip= window.location.host.split(":")[0]
          this.port= window.location.host.split(":")[1]
        }

         if ( this.ip!=null&& this.ip!=undefined&&this.ip!='null'){
            setValue('ip', this.ip);
            setValue('port', this.port);
         }
         //this.alert_ok(this.ip+":"+this.port)
      },
  isMobile() {
	 let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
	 return flag;
},

}
}


</script>

<style lang="scss">
@import "./assets/sass/base";
</style>



// WEBPACK FOOTER //
// src/App.vue